import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

const ArrowOK = ({ color = 'icon.original', ...props }) => (
  <IconBase viewBox='0 0 12 10' {...props}>
    <Path
      d='M10.8745 1.70312L7.61721 4.99724L4.35989 8.29136L0.992188 5.01817'
      stroke={color}
      strokeWidth='1.6'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='transparent'
    />
  </IconBase>
)

ArrowOK.propTypes = {
  color: PropTypes.string,
}

export default ArrowOK
